var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RoleTreeBody"},[_c('el-tree',{ref:"tree",attrs:{"check-strictly":"","default-expand-all":true,"data":_vm.treeData,"show-checkbox":"","check-on-click-node":"","expand-on-click-node":false,"node-key":"PowerId","props":{ label: 'PowerName' }},on:{"check":_vm.treeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }